import React, {useState} from 'react';

import './css/agent.css';
export default function InstallInstructions({token}) {


    return (

<div className={'SectionBoxEmbedded'}>
        <div className='InstallInstructions'>
            <div className='_section'>
                <div className='_static_summary'>
            <span className='_static_summary_text'>
                <div className="SectionSubHeadingEmbedded">INSTALLATION</div>
                <div className="_static_summary_div_line"></div>
                <p>
                    <div className="_note">
                    <b>NOTE - Please DO NOT</b> install the agent client on a GPU server that is listed on Vast.
                    We suggest you run it in a termux wrapper on a monitoring workstation or application / Web server.
                    WSL Ubuntu on Windows 10 / 11 OR Ubuntu 20.04 - 24.04 workstation / server, VM or baremetal.
                    </div>
                </p>
                <p>
                1. Using the exact commands listed below, install Vast Cli in the home directory, register your API key and test Vast CLI.
                </p>
                <code>
                $ cd ~/ <br/>
                $ wget https://raw.githubusercontent.com/vast-ai/vast-python/master/vast.py -O vast; chmod +x vast;<br/>
                    $ ./vast<br/>
                $ ./vast set api-key ********<br/>
            $ ./vast show machines<br/>
                </code><br/>

    <p>2. Install Java Runtime Environment 21 from Open JDK.
    </p>
    <code>
        $ sudo apt update <br/>
    $ sudo apt install openjdk-21-jre <br/>
    $ java -version <br/>
</code><br/>

    <p>
        3. You should see the Java JRE 21 help view with the version number.
    </p>
    <code>
        java version "21.0.1" 2023-10-17 LTS <br/>
    Java(TM) SE Runtime Environment (build 21.0.1+12-LTS-29) <br/>
    Java HotSpot(TM) 64-Bit Server VM (build 21.0.1+12-LTS-29, mixed mode, sharing) <br/>
</code>
<br/>
    <p>
        4. Download the Listing Agent JAR file to your home directory ( ~/ )
    </p>
    <code>
        $ cd ~/<br/>
    $ wget https://wovenai.ca/apps/ListingAgent-2.7.3.jar<br/>
        </code>
<br/>
    <p>
        5. Start a termux session to run in the background when you close your terminal / shell.
    </p>
    <code>
        $ sudo apt install tmux <br/>
    $ tmux new -s ListingAgent <br/>
</code>
<br/>
    <p>
        6. Launch the Listing Agent passing in your Woven API key.  Keep this key secure and do not share it.
    </p>
    <code>
        $ java -jar ./ListingAgent-2.7.3.jar {token}<br/>
</code>
                <br/>

    <p>
        7. Exit your tmux session by pressing <b>CTRL-B then D</b>. This will leave the session running.
    </p>
    <p>
        8. You can return to it by opening a shell and typing the following (and then <b>CTRL-B then D</b> again):
    </p>
    <code>
        $ tmux attach -t ListingAgent<br/>
</code>
<br/>
    <p>
        9. To stop the running agent, type <b>CTRL-C</b>.  To exit and close tmux session, type
    </p>
    <code>
        $ exit<br/>
</code>
<br/>
    <p>
        10. You can see the list of tmux sessions by typing:
    </p>
    <code>
        $ tmux ls <br/>
</code>
</span>

</div>
</div>



</div>
</div>
          );
}